/**
 * Verifica a situação do cadastro do usuário baseado na presença do faceId
 * @param user - Objeto do usuário
 * @returns 'COMPLETO' se tem faceId, 'INCOMPLETO' se não tem
 */
export function userSituation(user: any): 'COMPLETO' | 'INCOMPLETO' {
  // Verifica se o usuário existe e tem atributos
  if (!user || !user.attributes) {
    return 'INCOMPLETO';
  }

  const hasImage = user.image;

  // Procura por faceId nos atributos do usuário
  const hasFaceId = user.faceId;

  // Se não encontrou faceId, também pode estar em uma propriedade direta
  const hasDirectFaceId = user.faceId;

  return (hasFaceId || hasDirectFaceId || hasImage) ? 'COMPLETO' : 'INCOMPLETO';
}

/**
 * Verifica se o usuário tem faceId
 * @param user - Objeto do usuário
 * @returns true se tem faceId, false caso contrário
 */
export function hasFaceId(user: any): boolean {
  return userSituation(user) === 'COMPLETO';
}

export function hasImage(user: any): boolean {
  return userSituation(user) === 'COMPLETO';
}
